import React, { forwardRef, useState } from 'react';
import Props from './typing';
import { Tooltip } from 'antd';
import SVGIcon from '../../../SVGIcon';

const ListBlock = forwardRef<HTMLLIElement, Props>((props, ref) => {
  const [onHover, updateHover] = useState(false);
  const { className, onClick, isCollapsed, label, imgSrc, imgAlt, icon } = props;
  return (
    <>
      <li
        ref={ref}
        onMouseEnter={() => updateHover(true)}
        onMouseLeave={() => updateHover(false)}
        className={className ? className : ''}
      >
        <a
          href=''
          onClick={onClick}
          className={!isCollapsed ? 'border-radius-8' : 'center-align-content'}
        >
          <Tooltip
            visible={onHover && isCollapsed}
            placement='right'
            title={label}
          >
            {/* <img src={imgSrc} alt={imgAlt} /> */}
            {icon ? (
              <SVGIcon icon={icon} className={className ? className : ''} />
            ) : (
              <img src={imgSrc} alt={imgAlt} />
            )}
          </Tooltip>
          {!isCollapsed && <label className={className==="active" ? className : ''}>{label}</label>}
        </a>
      </li>
    </>
  );
});

ListBlock.displayName = 'ListBlock';

export default ListBlock;
